import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../service/user.service';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ChartType, ChartDataSets, ChartOptions,ChartData } from 'chart.js';

@Component({
  selector: 'app-submitted-order-popup',
  templateUrl: './submitted-order-popup.component.html',
  styleUrls: ['./submitted-order-popup.component.scss']
})
export class SubmittedOrderPopupComponent extends BaseComponent implements OnInit {
  @ViewChild('doughnutSubmittedOrder') doughnutSubmittedOrder!: ElementRef;
  chart: any;

  items = [];
  // fromDate: any;
  // toDate: any;
  // reportPeriod: any;
  // year: any;
  // month: any;
  // week: any;
  colorCount:number;
  currentYear=new Date().getFullYear();
  defaultChartData: any= null;
  defaultChartDataLength: number= null;

  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
  
// public barChartOptions = {
//   scales: {
//     y: {
//       type: 'logarithmic',
//       ticks: {
//         // Show meaningful ticks (e.g., powers of 10)
//         callback: (value) => {
//           const v = Number(value);
//           if ([1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000].includes(v)) return v;
//           return '';
//         }
//       },
//       min: 1, // log scales can’t go to 0
//       // Optionally: max: 10000
//     }
//   }
// };

  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 10,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

  chartData: number[]=[];
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'bar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];


  public doughnutChartLabels:string[] =[];
  public doughnutChartData:any[] =[];
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutColor: string[] = [];
  public doughnutDatasets: any[];
  public doughnutLabelArray: any[]=[];
  reportfromDate: any;
  reportToDate: any;
  doughnutChartColors:any[] =[];

  //#region ReportPeriod DropDown
  selectedReportPeriod: number;

  reportPeriods = [
        { id: 0, name: this.appTranslateService.getTranslate("Yearly") },
        { id: 1, name: this.appTranslateService.getTranslate("Monthly") },
        { id: 2, name: this.appTranslateService.getTranslate("Weekly") },
    ];

  //#endregion

  //#region Year DropDown

  // selectedYear= [];
  // years = [];

  // //#endregion

  // //#region Month DropDown

  // selectedMonth= [];
  // months = [
  //       { id: 0, name: this.appTranslateService.getTranslate("Select") },
  //       { id: 1, name: this.appTranslateService.getTranslate("January") },
  //       { id: 2, name: this.appTranslateService.getTranslate("February") },
  //       { id: 3, name: this.appTranslateService.getTranslate("March") },
  //       { id: 4, name: this.appTranslateService.getTranslate("April") },
  //       { id: 5, name: this.appTranslateService.getTranslate("May") },
  //       { id: 6, name: this.appTranslateService.getTranslate("June") },
  //       { id: 7, name: this.appTranslateService.getTranslate("July") },
  //       { id: 8, name: this.appTranslateService.getTranslate("August") },
  //       { id: 9, name: this.appTranslateService.getTranslate("September") },
  //       { id: 10, name: this.appTranslateService.getTranslate("October") },
  //       { id: 11, name: this.appTranslateService.getTranslate("November") },
  //       { id: 12, name: this.appTranslateService.getTranslate("December") },
  //     ];
  // //#endregion

  constructor(
     public activeModal: NgbActiveModal
    ,private loaderService: LoaderService
    ,private userService: UserService
    ,private chartService:ChartService
   )
  {
      super();
  }

  closeActiveModal(value) {
    this.activeModal.close(true);
  }

  ngOnInit(): void {

      //this.CreateChartSelectedDateWise();

  }

ngAfterViewInit() {
   this.CreateChart();


}

  CreateChart()
  {
    //console.log("CreateChart");
     const subArray: number[] = [];
     const colorArray: any[] = [];
      for (let i = 0; i < this.defaultChartData.length; i++) {
            this.doughnutChartLabels.push(this.defaultChartData[i].monthName)
            //this.doughnutChartData.push(this.defaultChartData[i].orderCount)
            subArray.push(this.defaultChartData[i].orderCount);
            var c=this.chartService.getColors(i+1);
                  colorArray.push(c); // Random color
                  
      this.doughnutChartColors.push(colorArray);
    }
    this.doughnutChartData.push(subArray);
   
    this.doughnutLabelArray.push(this.currentYear);

    if (this.chart) {
               
                this.chart.destroy();
              }
              this.chart=
              this.chartService.renderDougNutMultiLayerChart(             
              this.doughnutSubmittedOrder,
              this.doughnutChartLabels,
              this.doughnutChartData,
              this.doughnutChartColors,
              this.doughnutLabelArray
            );

            


  for (let i = 0; i < this.defaultChartData.length; i++) {
          this.barChartColors=[{backgroundColor:'#74acac'}] ;
          this.barChartLabels.push(this.defaultChartData[i].monthName)
          this.chartData.push(this.defaultChartData[i].orderCount)
    }
    this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];
  }

  CreateChartSelectedDateWise()
  {
     console.log("CreateChartSelectedDateWise");

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.doughnutChartLabels =[];
    this.doughnutChartData=[];
    this.doughnutColor=[];
    this.doughnutDatasets=[];
    this.doughnutLabelArray=[];
    this.loaderService.show();

    //this.chartService.renderChart(this.chart,this.doughnutSubmittedOrder,this.doughnutChartLabels,this.doughnutChartData,this.doughnutColor);
    if(this.items.length>0)
    {
      this.userService.GetDashboardPopupReport(this.items[0]["reportFromDate"],this.items[0]["reportToDate"],this.items[0]["period"],this.items[0]["year"],this.items[0]["month"],"GetSubmittedOrderReport").subscribe(
      ress => {
        this.loaderService.hide();
         if (ress.successed) {
          var data = ress.data;
             //console.log("success");
            
           //  console.log(data.dashboardPopupDoughChart);
             
          //#region  Barchart
          const rows = data.dashboardPopupBarChart || [];

          // Decide if we have "simple" (no subColumnName) or "grouped" data
          const hasSubColumns = rows.some(r => r?.subColumnName !== undefined && r?.subColumnName !== null && r?.subColumnName !== '' && r?.subColumnName !== 'undefined');

                if (!hasSubColumns) {
                  // ---- Simple case: only one series, labels are columnName (e.g., years) ----
                  this.barChartLegend = false;

                  this.barChartLabels = rows.map(r => String(r.columnName));
                  const series = rows.map(r => Number(r.columnValue) || 0);

                  this.barChartData = [{
                    data: series,
                    label: this.appTranslateService.getTranslate('Order')
                  }];

                  this.barChartColors = [{
                    backgroundColor: this.chartService.getChartColors(1).base,
                    hoverBackgroundColor: this.chartService.getChartColors(1).hover
                  }];
                } else {
                  // ---- Grouped case: one dataset per year, labels are months (union across all years) ----
                  this.barChartLegend = true;

                  // 1) Build union of months and sort them in calendar order
                  const MONTHS_ORDER = ['January','February','March','April','May','June','July','August','September','October','November','December'];

                  const monthSet = new Set<string>();
                  rows.forEach(r => monthSet.add(String(r.subColumnName)));

                  const labels = Array.from(monthSet).sort((a, b) => MONTHS_ORDER.indexOf(a) - MONTHS_ORDER.indexOf(b));

                  // Assign the global labels once
                  this.barChartLabels = labels;

                  // 2) Group values: Map<year, Map<month, value>>
                  const groups = new Map<string, Map<string, number>>();
                  rows.forEach(r => {
                    const year = String(r.columnName);
                    const month = String(r.subColumnName);
                    const value = Number(r.columnValue) || 0;

                    if (!groups.has(year)) {
                      groups.set(year, new Map<string, number>());
                    }
                    groups.get(year)!.set(month, value);
                  });

                  // 3) Build datasets aligned to the labels
                  this.barChartData = [];
                  this.barChartColors = [];

                  let colorIdx = 0;
                  for (const [year, monthMap] of groups) {
                    const series = labels.map(m => {
                      // Use 0 for missing month (bar with height 0). If you prefer no bar, use `null` instead.
                      return monthMap.get(m) ?? 0;
                    });

                    this.barChartData.push({ data: series, label: year });

                    this.barChartColors.push({
                      backgroundColor: this.chartService.getChartColors(colorIdx).base,
                      hoverBackgroundColor: this.chartService.getChartColors(colorIdx).hover
                    });
                    colorIdx++;
                  }
                  console.log("this.barChartColors",this.barChartColors);
                }
                console.log("this.barChartColors",this.barChartColors);
          //#endregion


             //#region  DoughNut
             const distinctEmployee = data.dashboardPopupDoughChart.filter(
                (dashboardPopupDoughChart, i, arr) => arr.findIndex(t => t.employeeName === dashboardPopupDoughChart.employeeName) === i);
            
             const distinctDate = data.dashboardPopupDoughChart.filter(
                (dashboardPopupDoughChart, i, arr) => arr.findIndex(t => t.date === dashboardPopupDoughChart.date) === i);
              
              this.doughnutChartData = [];
              this.doughnutChartColors = [];

               for (let i = 0; i < distinctDate.length; i++) {
                const subArray: number[] = [];
                const colorArray: any[] = [];
                
                for (let j = 0; j < distinctEmployee.length; j++) {                  

                    if(!this.doughnutChartLabels.some(item => item.includes(distinctEmployee[j].employeeName)))
                    {
                      this.doughnutChartLabels.push(distinctEmployee[j].employeeName);
                    }                     
                     const dataRow = data.dashboardPopupDoughChart.filter(data => data.date === distinctDate[i].date && data.employeeName===distinctEmployee[j].employeeName);
                       
                     if(dataRow.length === 0)
                     {                      
                        subArray.push(0);
                     }
                     else
                     {
                      subArray.push(dataRow[0].value);
                     }
                      var c=this.chartService.getColors(j+1);
                      colorArray.push(c); // Random color
                     
                }
                this.doughnutChartData.push(subArray);
                this.doughnutChartColors.push(colorArray);
                this.doughnutLabelArray.push(distinctDate[i].date);
              }
              
              if (this.chart) {
                
                this.chart.destroy();
              }
              //console.log(this.chart);
            this.chart=
            this.chartService.renderDougNutMultiLayerChart(             
              this.doughnutSubmittedOrder,
              this.doughnutChartLabels,
              this.doughnutChartData,
              this.doughnutChartColors,
              this.doughnutLabelArray
            );
console.log(" this.doughnutChartColors", this.doughnutChartColors);
//#endregiond

 
              
         } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.doughnutChartLabels =[];
    this.doughnutChartData=[];
    this.items=[];
    this.loaderService.hide();

  }
}


  public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      console.log(e);
    }

    onSelectAll(items: any) {
    //console.log(items);
  }

    onItemSelect(item: any) {
   // console.log(item);
    }
  SelectedPeriod()
  {

  }


 addItem(newItem: string) { 
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }

}
